import type { PublishDiffusionForProductMutationResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { partenaires } from '~/msw/mocks/diffusion'

export function publishDiffusionForProductHandler() {
  return http.post<
    { annonceId: string, codeProduit: string },
    never,
    PublishDiffusionForProductMutationResponse
  >('http://localhost:3000/api/v1/diffusions/:annonceId/publier/:codeProduit', ({ params }) => {
    const produit = partenaires.find(p => p.code === params.codeProduit)?.label ?? params.codeProduit
    return HttpResponse.json({
      produit,
      success: true,
      message: 'Annonce publiée avec succès',
    })
  })
}

// Variante « scenario » de l'endpoint : la publication d'un produit échoue (HTTP 500).
// Branchée via ?scenario=relaunchError et composée dans ~/msw/scenarios.ts.
export function publishDiffusionForProductErrorHandler() {
  return http.post(
    'http://localhost:3000/api/v1/diffusions/:annonceId/publier/:codeProduit',
    () => HttpResponse.json({ message: 'Échec de la publication' }, { status: 500 }),
  )
}
